import React from 'react';
import AccountSettings, {
  AccountSettingsTabComponent,
  Tab,
} from 'src/components/AccountSettings/AccountSettings';
import {ACCOUNT_SETTING_ROUTES} from 'src/components/AccountSettings/utils/utils';
import ProfileForm from './profile-form';

import {useDispatch} from 'react-redux';
import ContactInfoForm from 'shared/account-settings/components/ContactInfoForm';
import {SharedAccountSettings} from 'src/components/AccountSettings/AccountSettingsContext';
import {PARENT_FIELDS} from '../../../../redux/parent/actions';
import CRUDService from '../../../../services/CRUDService';
import {submitForm} from '../../../../user/actions';
import {getMedia} from '../../../../utils/mq';
import {PARENT_NOTIFICATION_SETTINGS} from '../notification-settings';
import ManageStudents from './ManageStudents';

type ParentAccountSettings = SharedAccountSettings & {
  _id: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  subdivision: string;
  country: string;
  postalCode: string;
  confirmedUnverifiedAddress: boolean;
  addressVerified: boolean;
};

const SettingsService = new CRUDService<ParentAccountSettings>('/v1/parents');

const tabs: Tab<ParentAccountSettings>[] = [
  {
    ...ACCOUNT_SETTING_ROUTES.profile,
    component: function ProfileTab({
      settings,
      saveSettings,
      setNavigationAnnouncement,
      ...props
    }: AccountSettingsTabComponent<ParentAccountSettings>) {
      return (
        <ProfileForm
          initialValues={settings}
          onSubmit={saveSettings}
          setNavigationAnnouncement={setNavigationAnnouncement}
          {...props}
        />
      );
    },
  },
  {
    ...ACCOUNT_SETTING_ROUTES.contact,
    component: function ContactInfoTab({
      settings,
      saveSettings,
      setNavigationAnnouncement,
      ...props
    }: AccountSettingsTabComponent<ParentAccountSettings>) {
      return (
        <ContactInfoForm
          initialValues={settings}
          // @ts-expect-error
          onSubmit={saveSettings}
          hideParentEmail={false}
          setNavigationAnnouncement={setNavigationAnnouncement}
          {...props}
        />
      );
    },
  },
  {
    ...ACCOUNT_SETTING_ROUTES['manage-students'],
    component: function ContactInfoTab({
      settings,
      saveSettings,
      setNavigationAnnouncement,
      ...props
    }: AccountSettingsTabComponent<ParentAccountSettings>): React.ReactElement {
      return (
        <ManageStudents
          initialValues={settings}
          onSubmit={saveSettings}
          hideParentEmail={false}
          setNavigationAnnouncement={setNavigationAnnouncement}
          {...props}
        />
      );
    },
  },
];

const fetchAccountSettings = (): Promise<ParentAccountSettings> =>
  SettingsService.show('me', {fields: `${PARENT_FIELDS},notificationSettings`});

const ParentAccountSettings = () => {
  const dispatch = useDispatch();

  return (
    <AccountSettings<ParentAccountSettings>
      tabs={tabs}
      fetchAccountSettings={fetchAccountSettings}
      availableNotificationSettings={PARENT_NOTIFICATION_SETTINGS}
      saveSettings={(newSettings: Partial<ParentAccountSettings>): Promise<ParentAccountSettings> =>
        submitForm(newSettings, '/v1/parents/', getMedia().MS_AND_DOWN, dispatch, false, true, true)
      }
    />
  );
};

export default ParentAccountSettings;
